export const OtelDbSystemAliases = {
  mongoose: 'mongodb',
  // Set to null if you want to ignore some db systems
  // sequelize: null,
}